/*
 * Copyright (c) 2018.  Spin in het Web BV Apeldoorn
 * Geen toestemming zonder gebruik zonder schriftelijke overeenkomst
 * Ook bij schriftelijke overeenkomst is het gebruik van deze code
 * beperkt tot de in de overeenkomst opgenomen voorwaarden.
 */

/**
 * SPIN IN HET WEB APELDOORN
 * User: Jelmer Jellema
 * Date: 12-3-2018
 * Time: 15:02
 *
 * Simpele service voor erroralert
 */

angular.module('myApp.erroralert',['sihw.confirm', 'sihw.sihwlog'])
    .factory('erroralert',[
        '$translate','sihwconfirm', 'sihwlog',
        function($translate, sihwconfirm, sihwlog) {
            let log = sihwlog.logLevel('warn');
            return function(err)
            {
                log.warn("Er is een fout opgetreden");
                log.warn(err);
                let melding = err.code ? "ERROR." + err.code : "ERROR.MISC";
                let melding_translated = $translate.instant(melding);
                if (melding_translated === melding)
                {
                    //missende vertaling
                    log.warn('Missende vertaling',melding);
                    melding_translated = $translate.instant("ERROR_MISC");
                }
                return sihwconfirm($translate.instant("ERROR.TITEL"),
                    melding_translated,
                    $translate.instant('ERROR.OK'),
                    false,
                    'erroralert');
            }
        }
    ]);
